import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.matchings.NetSuiteMatchingInfo.POFooter', {
    remainingBalance: 'Purchase Order Line remaining: <strong>{remainingBalance}</strong>',
});
